import { render, staticRenderFns } from "./ChooseTagBtn.vue?vue&type=template&id=18a7d426"
import script from "./ChooseTagBtn.vue?vue&type=script&lang=js"
export * from "./ChooseTagBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports